import PageLayout from "examples/LayoutContainers/PageLayout";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Footer from "layouts/authentication/components/Footer";
import SkipToContent from "components/SkipToContent";
import usePageTitle from "utils/usePageTitle";
// Fix the import path for pageRoutes
import pageRoutes from "page.routes";

// Importăm componentele secțiunilor
import HeroSection from "./sections/HeroSection";
import HeroSectionCarousel from "./sections/HeroSectionCarousel";
import ServicesSection from "./sections/ServicesSection";
import HowItWorksSection from "./sections/HowItWorksSection";
import ReportTypesSection from "./sections/ReportTypesSection";
import LegislationSection from "./sections/LegislationSection";
// import CallToAction from "./sections/CallToAction";
import { HandsBackgroundDecor } from "./sections/CallToAction";

// MUI Components
import SoftBox from "components/SoftBox";
// import Divider from "@mui/material/Divider";

function HomePage() {
  usePageTitle("Pagina principală");
  return (
    <PageLayout>
      <SkipToContent />
      <DefaultNavbar
        routes={pageRoutes}
        transparent
        action={{
          type: "external",
          route: "/formular-sesizare",
          label: "Trimite Sesizare",
          color: "info",
        }}
      />
      <SoftBox
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{ outline: "none", mt: { xs: "98px", md: "77px" } }}
      >
        <HeroSectionCarousel />
        {/* Zonă albă full-width — fundalul alb acoperă tot viewport-ul; doar
           un padding interior modest, fără maxWidth (altfel se vede bg-ul gri
           al PageLayout pe laterale). */}
        <SoftBox
          sx={{
            bgcolor: "#ffffff",
            overflow: "hidden",
            width: "100%",
            px: { xs: 2.5, sm: 3, md: 10, lg: 12 },
            pt: { xs: 3, md: 4 },
            pb: { xs: 4, md: 6 },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SoftBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 5, md: 7 },
            }}
          >
            <ServicesSection />
            <HowItWorksSection />
          </SoftBox>

          {/* Decor mâini în fundal (fără banner Depune sesizare) */}
          <SoftBox sx={{ position: "relative" }}>
            <HandsBackgroundDecor />
          </SoftBox>

          {/* Despartire vizuală + banner Depune sesizare — dezactivat temporar
          <Divider
            sx={{
              borderColor: "rgba(15, 44, 74, 0.14)",
              my: { xs: 4, md: 5.5 },
            }}
          />

          <CallToAction />
          */}
        </SoftBox>
      </SoftBox>

      <Footer />
    </PageLayout>
  );
}

export default HomePage;
